module.exports = {"533422101":"升平镇","533422102":"奔子栏镇","533422201":"佛山乡","533422202":"云岭乡","533422203":"燕门乡","533422204":"拖顶乡","533422205":"霞若乡","533422206":"羊拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533422.json
// module id = 2480
// module chunks = 0